import React, { useState } from "react";
import Modal from "react-modal";
import CustomButton from "../components/CustomButton";
import InputWithIcon from "../components/FormFields/InputWithIcon";

const EditApproveModal = ({
  isModalVisible,
  setIsModalVisible,
  approveHandler,
  ids = [],
  totalAmount = "",
  title = "Voucher"
}) => {
  
  const validationForEditAmountNotMoreThanPreviousAmount = true

  const PREVIOUS_AMOUNT = [...ids];

  const onRequestClose = () => {
    setIsModalVisible({ ...isModalVisible, isOpen: false });
  };

  const approveHan = (val) => {
    return approveHandler(val);
  };

  const [comment, setComment] = useState("");
  const [amounts, setAmounts] = useState(ids);
  // const [error, setError] = useState(false);
  const [error, setError] = useState({ comment: false, amount: false });

  
  const checkForAppoveTheAmount = (arr = []) => {
    // debugger
    return arr.every(i => Number(i.previousAm) >= Number(i.approvedAmount))
  }
  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isModalVisible.isOpen}
        onRequestClose={onRequestClose}

        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            // alignItems: 'center',
            borderRadius: "1rem",
            background: "#fff",
            padding: "1.5rem",
            // margin: "8rem 20rem",
            width: "30%",
            position: "relative",
          },
          overlay: {
            background: "#000000d6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1
          },
        }}
      >
        {/* <div className="text-[2rem] text-[red] absolute top-[-4.5rem] right-[0px]">
        Close <span className="text-[2.9rem]">[x]</span>
      </div> */}
        <div className="w-full" style={{ maxHeight: '71vh'}}>
          {/* Header */}
          <div className="flex justify-between relative w-[100%] text-2xl font-semibold">
            Edit {title}
            <div
              className="text-3xl cursor-pointer text-red-500 ml-4"
              onClick={() => setIsModalVisible(false)}
            >
              [x]
            </div>
          </div>
          <div className="mt-4">
            {amounts.map((amount, i) => {
              return (
                <div className="mb-4" key={i}>
                  <div>ENTER AMOUNT FOR ID {amount?.id}</div>
                  <InputWithIcon
                    inputClassName="h-40 w-full text-2xl mt-2"
                    containerClassName="!bg-white border"
                    onChange={(e) => {
                      let newAmounts = [...amounts];
                      newAmounts[i].approvedAmount = e;
                      setAmounts(newAmounts);
                      setError(false);
                    }}
                    value={amount?.approvedAmount}
                    // error={error.amount}
                    type="number"
                  />
                  {Number(amount.approvedAmount) > Number(amount.previousAm) && (
                    <span className="text-red-500 text-lg">
                      {"You cannot add more than " + Number(amount.previousAm)}
                    </span>
                  )}
                  {Number(amount.approvedAmount) === 0 && (
                    <span className="text-red-500 text-lg">
                      Please add a valid approved amount
                    </span>
                  )}
                </div>
              );
            })}
            {/* {error.amount && (
              <span className="text-red-500 text-lg">
                {"Please add valid approved amount"}
              </span>
            )} */}

            <div className="mt-4">WRITE REASON</div>
            <textarea
              className="h-40 w-full border text-2xl mt-2"
              onChange={(e) => {
                setComment(e.target.value);
                setError(false);
              }}
            />
            {error.comment && (
              <span className="text-red-500 text-lg">
                {"Please write comments before approve"}
              </span>
            )}
          </div>
          <div className="w-full flex justify-end">
            <CustomButton
              title="Edit and Approve"
              wrapperClassName="!px-10 mt-6 mb-4"
              style={{
                background: "white",
                color: "red",
                border: "1px solid red",
              }}
              onClick={() => {
                const { data = [] } = isModalVisible || {};
                // if (comment.length > 0) {
                //   approveHan({
                //     data: amounts,
                //     comment: comment,
                //   });
                // } else {
                //   setError(true);
                // }

                if(!validationForEditAmountNotMoreThanPreviousAmount){
                  if(!(comment.length > 0)) {
                    setError(prev => ({...prev, comment: true}))
                  }
                  if ((comment.length > 0)) {
                    approveHan({
                      data: amounts,
                      comment: comment,
                    });
                  } 
                } else {
                  if ((comment.length > 0) && (checkForAppoveTheAmount(ids))) {
                    if (amounts.some((amount) => Number(amount.approvedAmount) === 0)) {
                      // If any amount is zero, don't approve
                      setError(prev => ({...prev, amount: true}))
                      return;
                    }
                    approveHan({
                      data: amounts,
                      comment: comment,
                    });
                  } else {
                    // if((Number(PREVIOUS_AMOUNT) > Number(amounts[0].approvedAmount))){
                    //   setError(prev => ({...prev, amount: true}))
                    // }
                    if(!(comment.length > 0)) {
                      setError(prev => ({...prev, comment: true}))
                    }
                  } 
                }
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditApproveModal;
